@if (showError) {
  <div class="alert alert-danger" role="alert" [attr.aria-live]="'polite'">
    <div class="error-title" role="heading" aria-level="3">{{ errorTitle | translate }}</div>
    <div>{{ errorMessage | translate }}</div>
    @if (!isBeforeQuestionsStep && bookingService.isAutoLoadBookingQuestionsEnabled()) {
      <!-- [review-fix N-B] Recovery actions — the auto-load error state otherwise renders no
           question/nav and traps the customer with only a full page reload as a way out.
           AFTER mount only: on the BEFORE mount these buttons are wrong-flow — Retry
           runs the auto-load path (no service selected yet -> empty target -> skips straight to
           the personal form past service/slot selection) and Back has no bound handler. A BEFORE
           mount legacy 404 renders the plain alert, exactly as in pure before-mode. -->
      <div
        class="d-flex justify-content-end mt-3 cbsw-auto-load-error-actions"
        role="navigation"
        [attr.aria-label]="'Booking questions error actions'"
      >
        <div class="me-2">
          <app-button
            id="{{ 'booking-questions-error-back-btn' }}"
            (clickEvent)="backToSlotsFromError()"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            role="button"
            [attr.aria-label]="'error_messages.back_to_slots_aria' | translate"
            tabindex="0"
          >
            {{ 'form_fields.previous' | translate }}
          </app-button>
        </div>
        <div>
          <app-button
            id="{{ 'booking-questions-error-retry-btn' }}"
            (clickEvent)="retryAutoLoadFetch()"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            role="button"
            [attr.aria-label]="'error_messages.retry_aria' | translate"
            tabindex="0"
          >
            {{ 'error_messages.retry_button' | translate }}
          </app-button>
        </div>
      </div>
    }
  </div>
} @else if (questionsLoaded()) {
  <div
    [class]="'cbsw-booking-questions-step ' + customClass"
    role="region"
    [attr.aria-label]="'Booking questions'"
    [attr.aria-live]="'polite'"
  >
    <div [@fadeInFadeOut]="counter" role="group" [attr.aria-label]="'Question ' + (activeQuestion + 1) + ' of ' + widgetQuestions.length">
      @for (widgetQuestion of widgetQuestions; track widgetQuestion; let index = $index; let isFirst = $first; let isLast = $last) {
        @if (activeQuestion === index) {
          <app-booking-question-view
            [widgetQuestion]="widgetQuestion"
            [isFirst]="isFirst"
            [isLast]="isLast"
            [isBeforeQuestionsStep]="isBeforeQuestionsStep"
            (previousQuestionEvent)="decrement(); previousQuestion(isFirst, widgetQuestion)"
            (nextQuestionEvent)="increment(); nextQuestion(widgetQuestion)"
            (finishLastBookingQuestionEvent)="increment(); finishLastBookingQuestion(widgetQuestion)"
            (workerSelectAnswerInvalidatedEvent)="onWorkerSelectAnswerInvalidated($event)"
            role="form"
            [attr.aria-label]="'Question ' + (index + 1) + ' of ' + widgetQuestions.length"
          />
        }
      }
    </div>
  </div>
} @else {
  <div
    class="skeleton-box-card mt-4"
    role="status"
    [attr.aria-label]="'Booking questions'"
    [attr.aria-busy]="true"
  >
    <div class="row" role="list" [attr.aria-label]="'Loading question placeholders'">
      @for (questionsGhostElement of questionsGhostElements; track $index) {
        <div class="col-md-12" role="listitem">
          <div class="d-flex stats-card shadow" role="presentation" [attr.aria-hidden]="true">
            <div class="skeleton-animation w-100 d-flex justify-content-center flex-column gap-3">
              <div class="bar bar-1"></div>
              <div class="bar bar-2"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
